import {
  ThumbsUpDownTooltip,
  ThumbsUpDownFooter,
} from '@hotjar/webapp/components/ThumbsUpDownTooltip';
import { ThumbsUpDownTableButton } from '@hotjar/webapp/components/ThumbsUpDownTooltip/ThumbsUpDownTableButton';
import type { VotingAction } from '@hotjar/feedback/domain/common/Responses/VotingAction';
import { useState } from 'react';
import { useResponseFeedbackMutation } from '@hotjar/feedback';
import { useHelpHotjarUrl, useTranslation } from '@hotjar/translations';
import { getAnswerForVote, getVotingActionForAnswer } from './domain/VotesAnswerMapper';
import type { Answer } from './domain/Answer';

interface ResponseFeedbackTooltipProps {
  votingAction: VotingAction | null;
  siteId: number;
  surveyId: number;
  responseId: number;
  visible?: boolean;
  appendTo?: 'parent' | Element | ((ref: Element) => Element);
  color?: string;
}

export function ResponseFeedbackTooltip(props: ResponseFeedbackTooltipProps): JSX.Element {
  const { votingAction, siteId, surveyId, responseId, visible, appendTo = 'parent', color } = props;
  const helpHotjarUrl = useHelpHotjarUrl();
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-response.feedback-tooltip' });

  const [currentVotingAction, setcurrentVotingAction] = useState(votingAction);
  const feedbackMutation = useResponseFeedbackMutation();

  function handleAnswerChange(answer: Answer) {
    const newVotingAction = getVotingActionForAnswer(votingAction, answer);
    if (newVotingAction) {
      feedbackMutation.mutateAsync({ votingAction: newVotingAction, siteId, surveyId, responseId });
      setcurrentVotingAction(newVotingAction);
    }
  }

  return (
    <ThumbsUpDownTooltip
      questionLabel={t('question-label')}
      thumbsUpLabel={t('thumbs-up-label')}
      thumbsDownLabel={t('thumbs-down-label')}
      onAnswerChange={handleAnswerChange}
      footer={
        <ThumbsUpDownFooter
          text={t('footer-text')}
          href={`${helpHotjarUrl}/categories/115001323487?section=115002321827&selectedArticle=360008587793`}
        />
      }
      isLoading={false}
      answer={getAnswerForVote(currentVotingAction)}
      visible={visible}
      offset={-130}
      distance={20}
      interactiveBorder={20}
      appendTo={appendTo}
    >
      <ThumbsUpDownTableButton
        answer={getAnswerForVote(currentVotingAction)}
        labelNoAnswer={t('no-answer-label')}
        color={color}
      />
    </ThumbsUpDownTooltip>
  );
}
